<template>
  <div>
    <el-form ref="form" :rules="rules" :model="form" label-width="150px">
      <el-form-item label="是否收集身份证号">
        <el-switch
          v-model="form.collectIdNumber"
          active-color="#13ce66"
          inactive-color="#ff4949"
        >
        </el-switch>
      </el-form-item>
      <el-form-item label="是否收集收货地址">
        <el-switch
          v-model="form.collectAddress"
          active-color="#13ce66"
          inactive-color="#ff4949"
        >
        </el-switch>
      </el-form-item>
      <el-form-item label="是否收集身高体重">
        <el-switch
          v-model="form.collectHeightAndWeight"
          active-color="#13ce66"
          inactive-color="#ff4949"
        >
        </el-switch>
      </el-form-item>
      <el-form-item label="是否免费报名">
        <el-switch
          v-model="form.isFree"
          active-color="#13ce66"
          inactive-color="#ff4949"
        >
        </el-switch>
      </el-form-item>
      <el-form-item label="是否预报名（开启此选项时请同时开启免费报名）">
        <el-switch
          v-model="form.preRegister"
          active-color="#13ce66"
          inactive-color="#ff4949"
        >
        </el-switch>
      </el-form-item>
      <el-form-item label="是否开启战队填写">
        <el-switch
          v-model="form.enableTeam"
          active-color="#13ce66"
          inactive-color="#ff4949"
        >
        </el-switch>
      </el-form-item>
      <el-form-item label="是否收集年龄">
        <el-switch
          v-model="form.collectAge"
          active-color="#13ce66"
          inactive-color="#ff4949"
        >
        </el-switch>
      </el-form-item>
      <el-form-item label="是否收集生日">
        <el-switch
          v-model="form.collectBirthday"
          active-color="#13ce66"
          inactive-color="#ff4949"
        >
        </el-switch>
      </el-form-item>
      <el-form-item label="是否收集邮箱">
        <el-switch
          v-model="form.collectEmail"
          active-color="#13ce66"
          inactive-color="#ff4949"
        >
        </el-switch>
      </el-form-item>
      <el-form-item label="是否收集自媒体信息">
        <el-switch
          v-model="form.collectWeMedia"
          active-color="#13ce66"
          inactive-color="#ff4949"
        >
        </el-switch>
      </el-form-item>
      <el-form-item label="是否强制预定油彩">
        <el-switch
          v-model="form.enablePaint"
          active-color="#13ce66"
          inactive-color="#ff4949"
        >
        </el-switch>
      </el-form-item>
      <el-form-item v-if="form.enablePaint" label="油彩价格" prop="paintPrice">
        <el-input
          type="number"
          placeholder="请输入油彩价格"
          v-model="form.paintPrice"
        />
      </el-form-item>
      <el-form-item label="是否开启课程收费">
        <el-switch
          v-model="form.enableCourse"
          active-color="#13ce66"
          inactive-color="#ff4949"
        >
        </el-switch>
      </el-form-item>
      <el-form-item
        v-if="form.enableCourse"
        label="课程价格"
        prop="coursePrice"
      >
        <el-input
          type="number"
          placeholder="请输入课程价格"
          v-model="form.coursePrice"
        />
      </el-form-item>
      <el-form-item v-if="form.enableCourse" label="课程描述" prop="courseDesc">
        <el-input
          type="textarea"
          autosize
          placeholder="请输入课程描述"
          v-model="form.courseDesc"
        >
        </el-input>
      </el-form-item>
      <el-form-item v-if="form.enableCourse" label="课程介绍链接">
        <el-input placeholder="请输入课程介绍链接" v-model="form.courseUrl">
        </el-input>
      </el-form-item>
      <el-form-item label="是否收集学校信息">
        <el-switch
          v-model="form.collectSchool"
          active-color="#13ce66"
          inactive-color="#ff4949"
        >
        </el-switch>
      </el-form-item>
      <el-form-item label="是否收集学号">
        <el-switch
          v-model="form.collectStudentNumber"
          active-color="#13ce66"
          inactive-color="#ff4949"
        >
        </el-switch>
      </el-form-item>
      <el-form-item label="收费模式" prop="feeType">
        <el-radio-group v-model="form.feeType">
          <el-radio :label="1">主兼项收费</el-radio>
          <el-radio :label="2">按项目单独收费</el-radio>
        </el-radio-group>
      </el-form-item>
      <template v-if="form.feeType === 1">
        <el-form-item label="主项费用" prop="mainFee">
          <el-input
            type="number"
            placeholder="请输入主项费用"
            v-model="form.mainFee"
          />
        </el-form-item>
        <el-form-item label="兼项费用" prop="subFee">
          <el-input
            type="number"
            placeholder="请输入兼项费用"
            v-model="form.subFee"
          />
        </el-form-item>
        <el-form-item label="最大收费项目数" prop="maxItemLimit">
          <el-input
            type="number"
            placeholder="0表示不限制，超过后兼项不收费"
            v-model.number="form.maxItemLimit"
          />
          <div class="field-tip">仅主兼项收费模式生效；这是收费封顶数量，不限制运动员继续添加项目。</div>
        </el-form-item>
      </template>
      <el-form-item label="封顶费用" prop="maxFee">
        <el-input placeholder="请输入封顶费用" v-model.number="form.maxFee">
        </el-input>
      </el-form-item>
      <el-form-item label="添加报名项" prop="items">
        <div class="items-display">
          <div
            v-for="(item, index) in formObj.items"
            :key="index"
            class="items-display-parent"
          >
            <el-tag size="small" effect="dark"
              >{{ item.title }}({{ item.price }})</el-tag
            >
            <div
              v-for="(group, index) in item.groups"
              :key="index"
              class="items-display-children"
            >
              -- {{ group }}
            </div>
          </div>
        </div>
        <div class="item-card">
          <div class="item-card-item">
            <span>比赛项目（例如男子传统健美、男子古典健美）</span>
            <el-input placeholder="请输入项目名称" v-model="itemInfo.title" />
          </div>
          <div class="item-card-item">
            <span>项目分组（支持粘贴，每个项目一行）</span>
            <el-input
              type="textarea"
              autosize
              placeholder="请输入项目名称"
              :rows="4"
              v-model="itemInfo.groups"
            />
          </div>
          <!-- 收费模式为“按组别单独收费”时需填写 -->
          <div v-if="form.feeType === 2" class="item-card-item">
            <span>该组收费标准</span>
            <el-input
              type="number"
              placeholder="请输入该组别的费用"
              v-model="itemInfo.price"
            />
          </div>
          <el-button class="item-card-save" type="primary" @click="onItemSave"
            >保存</el-button
          >
        </div>
      </el-form-item>
      <el-form-item label="费用说明文案">
        <el-input
          type="textarea"
          autosize
          placeholder="请输入费用说明"
          v-model="form.costExplanation"
        />
      </el-form-item>

      <el-form-item label="是否开启优惠码填写">
        <el-switch
          v-model="form.enableCoupon"
          active-color="#13ce66"
          inactive-color="#ff4949"
        >
        </el-switch>
      </el-form-item>
      <el-form-item v-if="form.enableCoupon" label="优惠码说明文案">
        <el-input
          type="textarea"
          autosize
          placeholder="请输入如何获取优惠码的说明文案"
          v-model="form.couponDesc"
        />
      </el-form-item>

      <el-form-item label="支付配置">
        <div class="payment-config-block">
          <div class="item-card-item">
            <span>支付模式</span>
            <el-radio-group v-model="form.paymentMode">
              <el-radio label="platform">平台代收</el-radio>
              <el-radio label="service_provider">服务商分账</el-radio>
            </el-radio-group>
            <div class="field-tip">
              <span v-if="form.paymentMode === 'platform'">资金进入平台账户，适合小型赛事</span>
              <span v-if="form.paymentMode === 'service_provider'">资金直连主办方账户，适合大型赛事</span>
            </div>
          </div>

          <template v-if="form.paymentMode === 'service_provider'">
            <div class="item-card-item">
              <span>特约商户号</span>
              <el-input
                v-model="form.subMchId"
                placeholder="请输入主办方的微信特约商户号"
              />
              <div class="field-tip">主办方进件后获得的微信商户号</div>
            </div>

            <div class="item-card-item">
              <span>主办方名称</span>
              <el-input
                v-model="form.organizerName"
                placeholder="请输入主办方名称"
              />
              <div class="field-tip">对应特约商户号的主体名称，用于后台核对</div>
            </div>
          </template>

          <div class="item-card-item">
            <span>平台服务费设置</span>
            <div class="fee-setting-wrapper">
              <div class="fee-setting-item">
                <span class="label">服务费率（%）</span>
                <el-input-number
                  v-model="form.serviceFeeRate"
                  :min="0"
                  :max="100"
                  :precision="2"
                  :step="0.1"
                  placeholder="0"
                />
                <span class="unit">%</span>
                <div class="field-tip">例如：12.5 表示抽成 12.5%</div>
              </div>

              <div class="fee-setting-item">
                <span class="label">或固定服务费（元）</span>
                <el-input-number
                  v-model="form.serviceFeeFixed"
                  :min="0"
                  :precision="2"
                  placeholder="0"
                />
                <span class="unit">元</span>
                <div class="field-tip">固定金额优先于费率，二选一使用</div>
              </div>
            </div>
          </div>

          <div class="item-card-item">
            <span>微信手续费承担方</span>
            <el-radio-group v-model="form.feeBearer">
              <el-radio label="platform">平台承担</el-radio>
              <el-radio label="organizer">主办方承担</el-radio>
            </el-radio-group>
            <div class="field-tip">
              <span v-if="form.feeBearer === 'platform'">平台实收 = 抽成 - 0.6%手续费</span>
              <span v-if="form.feeBearer === 'organizer'">平台实收 = 抽成，手续费从主办方余款里扣</span>
            </div>
          </div>
        </div>
      </el-form-item>

      <el-form-item label="其他收费项">
        <div class="items-display">
          <div
            v-for="(item, index) in formObj.feeItems"
            :key="index"
            class="fee-display-item"
          >
            <div class="fee-display-line">
              <span class="fee-display-label">收费项标题：</span>
              <span class="fee-display-value">{{ item.title }}</span>
            </div>
            <div class="fee-display-line">
              <span class="fee-display-label">收费项价格：</span>
              <span class="fee-display-value">{{ item.price }}</span>
            </div>
            <div v-if="item.desc" class="fee-display-line">
              <span class="fee-display-label">收费项描述：</span>
              <span class="fee-display-value">{{ item.desc }}</span>
            </div>
            <div v-if="item.img" class="fee-display-line">
              <span class="fee-display-label">收费项图片：</span>
              <el-image
                style="width: 100px; height: 100px"
                :src="item.img"
                :preview-src-list="[item.img]"
              ></el-image>
            </div>
            <i class="el-icon-error fee-item-delete" @click="removeFeeItem(item.title)"></i>
          </div>
        </div>
        <div class="item-card">
          <div class="item-card-item">
            <span>收费项标题：</span>
            <el-input
              placeholder="请输入项目名称"
              v-model="feeItemInfo.title"
            />
          </div>
          <div class="item-card-item">
            <span>该项目收费标准：</span>
            <el-input
              type="number"
              placeholder="请输入项目费用"
              v-model="feeItemInfo.price"
            />
          </div>
          <div class="item-card-item">
            <span>收费项描述：</span>
            <el-input
              type="textarea"
              autosize
              placeholder="请输入项目描述"
              :rows="3"
              v-model="feeItemInfo.desc"
            />
          </div>
          <div class="item-card-item">
            <span>收费项图片：</span>
            <div>
              <el-upload
                class="image-upload"
                action=""
                :http-request="onUploadPoster"
                list-type="picture-card"
                :on-preview="handlePictureCardPreview"
                :limit="1"
              >
                <i class="el-icon-plus"></i>
              </el-upload>
              <el-dialog :visible.sync="imgPreviewDialogVisible">
                <img width="100%" :src="dialogImageUrl" alt="" />
              </el-dialog>
              <el-input
                v-model="feeItemInfo.img"
                placeholder="请输入收费项图片链接"
              ></el-input>
            </div>
          </div>
          <el-button
            class="item-card-save"
            icon="el-icon-circle-plus-outline"
            @click="onItemFeeSave"
            type="primary"
            >添加收费项目</el-button
          >
        </div>
      </el-form-item>
      <el-form-item label="联系方式">
        <template>
          <div class="register-item">
            <span class="label">联系方式类型</span>
            <el-select
              v-model="form.register.type"
              placeholder="请选择联系方式类型"
            >
              <el-option
                v-for="item in REGISTER_FORM_TYPE"
                :key="item.label"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
          <div class="register-item">
            <span class="label">报名截止时间</span>
            <el-date-picker
              v-model="form.deadline"
              type="datetime"
              format="yyyy-MM-dd HH:mm"
              default-time="23:59:00"
              placeholder="请选择报名截止时间"
            >
            </el-date-picker>
          </div>
          <div class="register-item">
            <span class="label"
              >联系方式（微信,电话,微信二维码,微信群二维码）</span
            >
            <el-upload
              v-if="[2, 3].includes(form.register.type)"
              action=""
              :http-request="onUploadQRcode"
              list-type="picture-card"
              :on-preview="handlePictureCardPreview"
              :limit="1"
              :file-list="qrcodeList"
            >
              <i class="el-icon-plus"></i>
            </el-upload>
            <el-input
              v-model="form.register.url"
              placeholder="请根据选择的联系方式类型填写联系方式信息"
            ></el-input>
          </div>
        </template>
      </el-form-item>
      <el-form-item label="Webhook地址" prop="webhook">
        <el-input
          placeholder="请输入飞书群机器人Webhook地址"
          v-model="form.webhook"
        />
      </el-form-item>
      <el-form-item label="备注">
        <el-input
          type="textarea"
          autosize
          placeholder="请输入备注内容"
          v-model="form.remarks"
        >
        </el-input>
      </el-form-item>
      <el-form-item label="关联文案" prop="connectionDesc">
        <el-input placeholder="请输入关联文案" v-model="form.connectionDesc" />
      </el-form-item>
      <el-form-item label="关联链接" prop="connectionUrl">
        <el-input
          placeholder="请输入关联链接（网页、小程序短链）"
          v-model="form.connectionUrl"
        />
      </el-form-item>

      <el-form-item class="footer-btn">
        <el-button type="primary" @click="onSubmit">{{
          type === "edit" ? "保存修改" : "立即创建"
        }}</el-button>
        <el-button>取消</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import _ from "loadsh";
import { REGISTER_FORM_TYPE } from "./constant";
import uploadMixin from "../../mixin/upload";

export default {
  props: {
    formObj: {
      type: Object,
      default: () => ({
        collectIdNumber: false,
        collectAddress: false,
        enableTeam: false,
        enablePaint: false,
        paintPrice: "",
        collectSchool: false,
        collectAge: true,
        collectBirthday: false,
        collectEmail: false,
        collectWeMedia: false,
        enableCourse: false,
        coursePrice: "",
        courseUrl: "",
        feeType: 1,
        mainFee: "",
        subFee: "",
        maxItemLimit: 0,
        maxFee: "",
        deadline: "",
        register: {
          type: 0,
          url: "",
        },
        costExplanation: "",
        webhook: "",
        remarks: "",
        items: [],
        connectionDesc: "",
        connectionUrl: "",
        feeItems: [],
        isFree: false,
        preRegister: false,
        collectStudentNumber: false,
        collectHeightAndWeight: false,
        enableCoupon: false,
        couponDesc: "",
        // 支付配置字段
        paymentMode: 'platform',
        subMchId: '',
        organizerName: '',
        serviceFeeRate: 0,
        serviceFeeFixed: 0,
        feeBearer: 'organizer'
      }),
    },
    type: {
      type: String,
      default: "add",
    },
  },
  mixins: [uploadMixin],
  mounted() {
    // 编辑时处理数据回显：将后端数据转换为前端显示格式
    if (this.type === 'edit' && this.formObj) {
      // 将费率从小数转换为百分比（0.125 -> 12.5）
      if (this.formObj.serviceFeeRate !== undefined && this.formObj.serviceFeeRate !== null) {
        this.formObj.serviceFeeRate = this.formObj.serviceFeeRate * 100;
      }
      // 将固定服务费从分转换为元（10000 -> 100）
      if (this.formObj.serviceFeeFixed !== undefined && this.formObj.serviceFeeFixed !== null) {
        this.formObj.serviceFeeFixed = this.formObj.serviceFeeFixed / 100;
      }
    }
  },
  data() {
    return {
      REGISTER_FORM_TYPE,
      showFuzzyTime: false,
      addedEvents: [],
      rules: {
        items: [
          {
            type: "array",
            required: true,
            message: "请至少添加一个比赛项目",
            trigger: "change",
          },
        ],
        paintPrice: [
          {
            required: true,
            message: "请填写油彩费用",
            trigger: "blur",
          },
        ],
        mainFee: [
          {
            required: true,
            message: "请填写主项费用",
            trigger: "blur",
          },
          {
            validator: (_rule, value, callback) => {
              if (value === '' || value === null || value === undefined) {
                callback(new Error('请填写主项费用'));
              } else if (isNaN(value) || Number(value) < 0) {
                callback(new Error('主项费用必须是大于等于0的数字'));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
        subFee: [
          {
            required: true,
            message: "请填写兼项费用",
            trigger: "blur",
          },
          {
            validator: (_rule, value, callback) => {
              if (value === '' || value === null || value === undefined) {
                callback(new Error('请填写兼项费用'));
              } else if (isNaN(value) || Number(value) < 0) {
                callback(new Error('兼项费用必须是大于等于0的数字'));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
        coursePrice: [
          {
            required: true,
            message: "请填写课程价格",
            trigger: "blur",
          },
        ],
        courseDesc: [
          {
            required: true,
            message: "请填写课程描述",
            trigger: "blur",
          },
        ],
        subMchId: [
          {
            required: true,
            message: "请填写特约商户号",
            trigger: "blur",
          },
          {
            pattern: /^\d+$/,
            message: "商户号必须为数字",
            trigger: "blur",
          },
        ],
        organizerName: [
          {
            required: true,
            message: "请填写主办方名称",
            trigger: "blur",
          },
        ],
      },
      qrcodeList: [],
      itemInfo: {
        title: "",
        groups: "",
        price: "",
      },
      feeItemInfo: {
        title: "",
        price: "",
        desc: "",
        img: "",
      },
    };
  },
  computed: {
    form() {
      return this.formObj;
    },
  },
  methods: {
    onSubmit() {
      this.$refs["form"].validate((valid) => {
        if (!valid) {
          return this.$message.error("表单信息填写错误，请根据提示检查！");
        }
        if (!this.formObj.items.length) {
          return this.$message.error("项目不能为空！");
        }
        if (!this.formObj.register.url) {
          return this.$message.error("联系方式不能为空！");
        }

        // 验证支付配置字段
        if (this.form.paymentMode === 'service_provider') {
          if (!this.form.subMchId) {
            return this.$message.error("请填写特约商户号！");
          }
          if (!/^\d+$/.test(this.form.subMchId)) {
            return this.$message.error("商户号必须为数字！");
          }
          if (!this.form.organizerName) {
            return this.$message.error("请填写主办方名称！");
          }
        }

        // 处理支付配置数据转换
        const params = {
          eventId: this.$route.query.id,
          ...this.form,
        };

        // 将服务费率从百分比转换为小数（12.5% -> 0.125）
        if (params.serviceFeeRate) {
          params.serviceFeeRate = params.serviceFeeRate / 100;
        }

        // 将固定服务费从元转换为分（100元 -> 10000分）
        if (params.serviceFeeFixed) {
          params.serviceFeeFixed = Math.round(params.serviceFeeFixed * 100);
        }

        const url = "/form-define/add";
        console.log(params, url);
        this.$axios
          .post(url, JSON.stringify(params), {
            headers: {
              "x-auth-token": localStorage.getItem("bde_token"),
            },
          })
          .then((res) => {
            if (res.data.code === "success") {
              this.$message.success("操作成功！");
              this.$emit("edit-success");
              this.addedEvents = [];
              this.$router.push("/");
            } else {
              this.$message.error("请求错误！");
            }
          })
          .catch((err) => {
            console.log(err);
            this.$message.error(err.response.data.message);
            if (err.response.data.code === "token_timeout") {
              this.$message.error("登录过期，请重新登录！");
            }
          });
      });
    },

    addEvent() {
      this.$prompt("请输入比赛项目名称", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /^.{2,50}$/,
        inputErrorMessage: "项目名称格式不正确",
      })
        .then(({ value }) => {
          this.addedEvents.push(value);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消输入",
          });
        });
    },
    handleClose(tag) {
      this.form.events.splice(this.form.events.indexOf(tag), 1);
    },
    onUploadPoster(param) {
      this.uploadImg(param, {
        onSuccess: (data) => {
          this.feeItemInfo.img =
            "https://cdn.jirou.fit/" +
            data.uploadResult.ImageUri +
            "~tplv-700tmnc25s-yasuo.image";
          this.$message.success("图片上传成功");
        },
        onError: () => {
          this.$message.error("上传失败");
        }
      });
    },
    onUploadQRcode(param) {
      this.uploadImg(param, {
        onSuccess: (data) => {
          this.formObj.register.url =
            "https://cdn.jirou.fit/" +
            data.uploadResult.ImageUri +
            "~tplv-700tmnc25s-yasuo.image";
          this.$message.success("图片上传成功");
        },
        onError: () => {
          this.$message.error("上传失败");
        }
      });
    },
    onItemSave() {
      if (!this.itemInfo.title || !this.itemInfo.groups) {
        return this.$message.error("请输入项目名称和项目组别");
      }
      const temp = {
        title: this.itemInfo.title,
        price: this.itemInfo.price,
        groups: this.itemInfo.groups.split("\n"),
      };
      this.formObj.items.push(temp);
    },
    onItemFeeSave() {
      if (!this.feeItemInfo.title || !this.feeItemInfo.price) {
        return this.$message.error("请输入收费项标题和价格");
      }
      this.formObj.feeItems.push(_.cloneDeep(this.feeItemInfo));
      // this.feeItemInfo.title = "";
      // this.feeItemInfo.desc = "";
      // this.feeItemInfo.price = "";
      // this.feeItemInfo.img = "";
    },
    removeFeeItem(title) {
      const index = _.findIndex(this.formObj.feeItems, {'title': title});
      if (index === -1) return;
      this.formObj.feeItems.splice(index, 1);
    }
  },
};
</script>

<style scoped>
.register-item {
  min-height: 50px;
}

.register-item > .label {
  display: inline-block;
  margin-right: 10px;
}

.contact-item {
  margin-bottom: 20px;
}

.contact-item > .label {
  margin: 0 10px 0 20px;
}

.contact-item > span:first-child {
  margin-left: 0;
}

.footer-btn {
  margin-top: 100px;
}

.text-btn {
  display: inline-block;
  margin-left: 20px;
}

.image-upload {
  margin-bottom: 10px;
}

.item-card {
  margin-top: 10px;
  border-radius: 20px;
  border: 1px dashed #666;
  padding: 20px;
}
.item-card-save {
  margin-top: 10px;
}
.items-display-parent {
  line-height: 20px;
}
.items-display-children {
  margin-left: 20px;
  line-height: 20px;
  color: #666;
}
.fee-display-item {
  position: relative;
  padding: 10px 20px;
  border-radius: 20px;
  box-shadow: rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px;
}
.fee-item-delete {
  position: absolute;
  right: 10px;
  top: 10px;
  cursor: pointer;
}
.fee-display-line {
  display: flex;
  margin-bottom: 2px;
  line-height: 20px;
}
.fee-display-label {
  margin-right: 5px;
  color: #999;
}
.fee-display-value {
  color: #333
}
.payment-config-block {
  margin-top: 10px;
  border-radius: 20px;
  border: 1px dashed #666;
  padding: 20px;
}
.item-card-item {
  margin-bottom: 20px;
}
.item-card-item:last-child {
  margin-bottom: 0;
}
.item-card-item > span {
  display: block;
  margin-bottom: 8px;
  color: #606266;
  font-size: 14px;
  font-weight: 500;
}
.block-title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 1px dashed #666;
}
.field-tip {
  margin-top: 5px;
  font-size: 12px;
  color: #909399;
  line-height: 1.5;
}
.fee-setting-wrapper {
  display: flex;
  flex-direction: column;
  gap: 15px;
}
.fee-setting-item {
  display: flex;
  align-items: center;
  gap: 10px;
}
.fee-setting-item .label {
  min-width: 140px;
  color: #606266;
  font-size: 14px;
}
.fee-setting-item .unit {
  margin-left: 5px;
  color: #909399;
}
</style>
